<template>
  <div class="city-selection">
    <div class="city-selection-title" :class="{'underline':mode=='underline'}">
        <div class="city-selection-title-text" v-if="mode=='home'">目的地/城市</div>
        <i class="iconfont icon-dizhi" v-else></i>
        <el-input v-model="inputValue" placeholder="请输入城市名称" class="city-input"  @input="searchCity" @focus="handleClick" @blur="handleBlur"></el-input>
        <!--删除按钮-->
        <i v-if="canChange&&inputValue!=''" class="el-icon-error" @click="clearCity"></i>
    </div>
    <!--城市选择-->
    <div class="city-list" :class="{'adjust':adjust}" v-if="contentShow">
        <div v-if="modifys&&inputValue!=''" class="search-list-container">
            <ul class="search-list">
                <li v-for="(item,index) in searchList" :key="item.id" :class="{'searchActive':index==searchDefault}" @mouseenter="changeSearchDefault(index)" >
                    <i class=" iconfont icon-jituanqiye"></i>
                    <p class="search-list-item-text" v-html="$verify.highlightKeyword(item.title, formData.name)"></p>
                    <span v-if="item.level==3">{{item.origin.searchText}}</span>
                    <p class="search-list-item-type">城市</p>
                </li>
            </ul>
            <div v-if="searchList.length==0" class="search-list-empty">
                <p>暂无相关城市信息</p>
            </div> 
        </div>
        <template v-else>
            <template v-if="cityList.length>0">
                <div class="city-list-tab">
                    搜索记录
                </div>
                <div v-for="item in hotCityList" :key="item.name" class="city-list-content"  >   
                    <ul class="search-list">
                        <li v-for="(item,index) in cityList" :key="item.id" :class="{'searchActive':index==modifysTab.index&&modifysTab.id==2}" @mouseenter="changeSearchModifystab(2,index)"  >
                            <i class=" iconfont icon-jituanqiye"></i>
                            <p class="search-list-item-text" >{{ item.title }}</p>
                            <span v-if="item.level==3">{{item.origin.searchText}}</span>
                            <p class="search-list-item-type">城市</p>
                        </li>
                    </ul>
                </div> 
            </template>
            <div class="city-list-tab" >
                热门城市
            </div>
            <div v-for="(item,index) in hotCityList" :key="index" class="city-list-content" >   
                <ul  class="city-list-content-list">
                    <li v-for="(city,index) in item.cityList" :key="city.id" @click.stop="selectCity(city)" :class="{'active':index==modifysTab.index&&modifysTab.id==1}" @mouseenter="changeSearchModifystab(1,index)">{{ city.title }}</li>
                </ul>
            </div> 
        </template>
    </div>
    <!--遮罩层-->
<!-- 页面内部占位，实际DOM会移到body -->
<!-- <el-dialog
  :visible.sync="show"
  width="0"
  class="city-selection-dialog"
  :lock-scroll="false"
  z-index="2"
  :close-on-press-escape="false"
  :show-close="false"
  ></el-dialog> -->
  </div>
</template>

<script>
import provinces from '@/assets/utils/provinces'
import {mapActions} from 'vuex'
export default {
  name: 'CitySelection',
  components: {},
  props: {

    //搜索值
    searcValue:{
        type:Object,
        default:()=>{}
    },
    //切换样式
    adjust:{
        type:Boolean,
        default:false
    },
    //模式
    mode: {
        type: String,
        default: 'home'
    },
    //可删除模式
    canChange:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
       
        formData:{
            name:'杭州',
            cityName:'杭州',
            city:'940',
            districtName:'',
            district:''
        },
        name:'杭州',
        modifys:false,       //是否修改了输入框
        cityIndex:0,         //当前城市索引
        hotCityList: [],
        searchIndex: new Map(),        // 检索索引
        searchList: [],                // 搜索列表
        searchDefault:0,               // 检索列表默认值
        contentShow:false,
        cityList:[],                    //历史选择的城市列表   
        modifysTab:{
            id:1,
            index:0                    //未搜索tab值
        },                                   
    };
  },
  computed: {
    inputValue:{
      get(){
        // 读
        return this.mode === 'home' ? this.formData.name : this.formData.cityName
      },
      set(val){
        this.formData.name = val
        if(this.mode=='underline'){
            this.formData.cityName = val
        }
      }
    },
  },
  watch: {
    //可清空城市
    canChange:{
        handler(newVal,oldVal){
            console.log(newVal,666);
            if(newVal){
                this.formData.name = '';
                this.formData.cityName = '';
                this.formData.city = '';
                this.name = '';
            }
        },
        immediate:true,
    },
    // infoLise: {
    //     handler(newVal,oldVal){
    //         if(newVal){
    //             this.hotCityList = [ {name:'热门',cityList:newVal.hot}];
    //         }
    //     },
    // },
    show(newVal) {
      if (newVal) {
        // 将元素移动到body下
        this.el = this.$refs.maskWrap
        document.body.appendChild(this.el)
      } else {

        if(this.el && this.el.parentNode){
          this.el.parentNode.removeChild(this.el)
        }
      }
    }
  },
  created() {
    const indexArr =provinces
    .filter(item => item.level !== 1)
    .map((item, idx) => {
      const searchStr = (item.title || '').toLowerCase()
      if(item.level!=1){
        return {
            id: item.id,
            up: item.up,
            searchText: searchStr,
            origin: item // 存原始对象，匹配后直接取出渲染
        };
      }
    })
    this.searchIndex=indexArr;
    //从本地获取当前选择的城市列表
    let cityList = localStorage.getItem('cityList');
    if(cityList){
        this.cityList = JSON.parse(cityList);
    }
    //获取热门城市列表
    this.infoLise();

  },
  mounted() {
  },
  methods: {
    ...mapActions(['POST_GetAllCity']),
    //热门城市列表
    async infoLise(){
        let res = await this.POST_GetAllCity({});
        if(res){
            this.hotCityList = [ {name:'热门',cityList:res.hot}];
        }
    },
    //切换城市
    changeCity(index,name){
        let hotCityList=[];
        if(name=='热门城市'){
            hotCityList = [ {name:'热门',cityList:this.infoLise.hot}];
        }else{
            let str = name.split("");
            str.map(item=>{
                hotCityList.push({
                    name:item,
                    cityList:this.infoLise.info[item]
                })
            });
        }
        this.hotCityList = hotCityList;
        this.cityIndex = index;
    },
    //获取焦点时显示城市列表
    handleClick(){
        this.contentShow=true;
        this.modifys = false;
    },
    //失去焦点时隐藏城市列表
    handleBlur(){
        let data = {};
        if(this.searchList.length>0){
            data = this.searchList[this.searchDefault];
            //保存本地当前选择的城市列表
            //按ID去重
            let historyCity=this.cityList.filter(todo=>todo.id!=data.id);
            historyCity.unshift(data);
            console.log(historyCity,'historyCity');
            //3. 截取前 5个元素，限制长度
            historyCity=historyCity.slice(0, 5);
            this.cityList = historyCity;
            //保存本地当前选择的城市列表
            localStorage.setItem('cityList',JSON.stringify(historyCity));
        }else{
            data =this.modifysTab.id==1?this.hotCityList[0].cityList[this.modifysTab.index]:this.cityList[this.modifysTab.index];
        }
        this.selectCity(data);
        this.contentShow=false;
    },
    //选择城市
    selectCity(data){
        //更新当前选择的城市列表
        let level = data.level||0;
        this.formData.name = level==3?data.origin.searchText:data.title;
        this.formData.cityName = level==3?data.origin.searchText:data.title;
        this.cityName = level==3?data.origin.searchText:data.title;
        this.formData.cityId=level==3?data.origin.id:data.id;
        this.contentShow=false;
        if(level==3){
            this.formData.districtName = data.title;
            this.formData.district = data.id;
            this.formData.name= this.formData.name+','+data.title;

        }else{
            this.formData.districtName = '';
            this.formData.district = '';
        }
        this.name = this.formData.name;
        let params = {...this.formData};
        delete params.name;
        delete params.districtName;
        this.$emit('formData',params);
    },
    //清除城市
    clearCity(){
        let formData={
            name:'',
            cityName:'',
            city:'',
            districtName:'',
            district:''
        }
        this.formData = formData;
        this.name = '';
        this.$emit('formData',formData);
    },
    //搜索城市
    searchCity(){
        this.modifys = true;
        //搜索关键字筛选
        if(this.formData.name){
            const timer = setTimeout(() => {
                this.doSearch(this.formData.name.trim());
                this.contentShow = true;
              }, 250);
        };
    },
    //搜索结构
    doSearch(keyword) {
        const { searchIndex} = this;
        const kw = keyword.toLowerCase();
        const result = searchIndex
          .filter(item => item.searchText.includes(kw))
          .map(item => {
            return {
                ...item.origin,
                origin:searchIndex.find(e => e.id === item.up)
            }       
        });
        console.log(result,'result');
        this.searchList = result;
        this.searchDefault = 0;
    },
    //鼠标进入修改默认值
    changeSearchDefault(index){
        this.searchDefault = index;
    },
    //鼠标进入修改默认值
    changeSearchModifystab(id,index){
        this.modifysTab.id = id;
        this.modifysTab.index = index;
    },
    //获取热门城市列表
    // async getHotCity(){
    //     let res = await this.POST_GetAllCity({});
    //     if (res.code === '00000'){
    //         this.hotCityList =[ {name:'热门',cityList:res.hot}] ;
    //         this.infoLise = res;
    //     }
    // }
  }
};
</script>

<style lang="scss" scoped>
.city-list{
    position: absolute;
    top: 70px;
    left: -2px;
    width: 500px;
    background-color: #Fff;
    border-radius: 6px;
    box-shadow: 0 2px 9px #999;
    z-index: 9;

}
.search-list-container{
    max-height: 400px;
    overflow: auto;
}
.adjust{
    top:50px;
    --tw-shadow: 0 0 15px 0px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow:  var(--tw-shadow);
}
.city-list::after {
  content: "";
    position: absolute;
    top: -12px;     /* 贴在底部 */
    left: 70px;     /* 水平居中 */
    margin-left: -6px;
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #ffffff transparent;
}
.city-list-tab{
    width: 90%;
    padding: 6px 5%;
    color: #666;
    display: flex;
    background-color: #f6f8fa;
    margin-top: 10px;

}
.city-list-tab div{
    width: 50%;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
}
.city-list-tab .active{
    color: var(--smtc-color-primary); 
    font-weight: bold;
}

.city-list-content{
    color: #333;
    display: flex;
    width: 100%;
    padding: 0;
    border-top: 1px #eee solid; 
}
.city-list-content-title{
    width: 5%;
    line-height: 24px;
    color:var(--smtc-color-primary)
}
.city-list-content-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
}
.city-list-content-list li{
    width: 20%;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}
.city-list-content-list li:hover{
    color: var(--smtc-color-primary); 
}
.city-list-content-list .active{
    color: var(--smtc-color-primary); 
}
.city-selection-title{
    color: #333;
    text-align: left;
    padding: 6px 12px;
    width: 200px;
    position: relative;
}
.search-list{
    color: #333;
    width: 100%;
    li{
        display: flex;
        padding: 10px 4%;
        cursor: pointer;
        span{
            margin-left: 16px;
        }
    }
    .searchActive{
        background-color: var(--smtc-color-TextBackground-blue);
    }
}
.search-list-item-text{
    margin-left: 16px;
}
.search-list-item-type{
    margin-left: auto;
    color: #999;
}
.mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2;
}
.city-selection{
    z-index:14;
    position: relative;
}
.search-list-empty{
    color: #999;
    line-height: 40px;
    text-align: center;
}
.underline{
    display: flex;
    padding: 12px 12px;
    line-height: 30px;
    padding-top: 15px;
    width: 150px;
    i{
        color: var(--smtc-color-primary);
        margin-right: 8px;
    }
}
.el-icon-error{
    color: #999 !important;
    position: absolute;
    right: 2px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
}

</style>
<style>
    .city-input .el-input__inner{
        height: 30px;
        line-height: 30px;
        border:initial !important;
        font-size: 14px;
        padding: 0;
        font-weight: bold;
        background-color:inherit;
    }
    .underline .city-input .el-input__inner{
        font-weight:initial;
    }
</style>
